import { render, staticRenderFns } from "./RejectedModal.vue?vue&type=template&id=8ade5218"
import script from "./RejectedModal.vue?vue&type=script&lang=js"
export * from "./RejectedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ade5218')) {
      api.createRecord('8ade5218', component.options)
    } else {
      api.reload('8ade5218', component.options)
    }
    module.hot.accept("./RejectedModal.vue?vue&type=template&id=8ade5218", function () {
      api.rerender('8ade5218', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Lobby/Modal/RejectedModal.vue"
export default component.exports